import { useQuery } from '@apollo/client';
import { GET_CALLS_GROUPED_BY_STATUS } from '../graphql/queries';

export interface CallsGroupedByStatus {
  executionDate: string;
  status: string;
  count: number;
}

interface UseCallsGroupedByStatusProps {
  startDate: Date;
  endDate: Date;
  agentId?: string;
  minDurationSecs?: number;
  maxDurationSecs?: number;
  callDirection?: 'incoming' | 'outgoing';
}

export const useCallsGroupedByStatus = ({
  startDate,
  endDate,
  agentId,
  minDurationSecs,
  maxDurationSecs,
  callDirection,
}: UseCallsGroupedByStatusProps) => {
  const { loading, error, data } = useQuery(GET_CALLS_GROUPED_BY_STATUS, {
    variables: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      ...(agentId && { agentId }),
      minDurationSecs,
      maxDurationSecs,
      callDirection,
    },
  });

  return {
    loading,
    error,
    data: data?.getCallsGroupedByStatus as CallsGroupedByStatus[] | undefined,
  };
};
